import { GzSingleSelectPhoneCodeWebComponent } from './component/GzSingleSelectPhoneCodeWebComponent';

export { GzSingleSelectPhoneCodeWebComponent };
